export class StringFormatter {

    /**
     * Fills a format string with given parameters
     */
    public static format(formatString: string, ...params: Array<string>): string {
        if (!formatString) {
            return formatString;
        }

        let replacedFormatString = formatString;
        for (let i = 0; i < params.length; i++) {
            const regex = new RegExp('\\{' + i + '\\}', 'gi');
            // Passing in a function to replace to bypass special replacement patterns. See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace#Specifying_a_string_as_a_parameter
            replacedFormatString = replacedFormatString.replace(regex, () => params[i]);
        }
        return replacedFormatString;
    }

    /**
     * Takes the old name and gives out the new copy name in the format of ex: Forms -> Forms (2)
     * @param oldName
     */
    public static getDuplicateItemName(oldName: string): string {
        // Match 0: whole name
        // Match 1: name base without duplicate number ex. (0)
        // Match 2: duplicate number ex. 10
        const matches: RegExpMatchArray = oldName.match(/(.*)\(([0-9]+)\)$/i);
        const newNameConstructor = (base: string, idx: number) => base.trim() + ` (${idx})`;
        if (!matches) {
            // adds a duplicate number
            return newNameConstructor(oldName, 2);
        } else {
            // increments a duplicate number
            return newNameConstructor(matches[1], parseInt(matches[2]) + 1);
        }
    }
}
